// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2Crim","productName":"Table_productName__1HeVq"};